import { CreateOrderWizard } from '@/components/organisms/recipe';
import { RoutePath } from '@/config';

import { useNavigate } from 'react-router-dom';

export const ClientCreateOrderPage = () => {
  const navigate = useNavigate();

  // Открываем сразу созданный заказ: id уходит в state роутера, список
  // текущих заказов по нему разворачивает нужную карточку.
  const handleComplete = (orderId?: number) => {
    navigate(RoutePath.ClientCurrentOrder, {
      replace: true,
      state: orderId ? { orderId } : undefined,
    });
  };

  const handleBack = () => {
    navigate(-1);
  };

  return <CreateOrderWizard onComplete={handleComplete} onBack={handleBack} />;
};
